import { AxiosError, AxiosResponse } from "axios";
import http from "utilities/http-common";
const baseUrl = "/api/Department";

export async function getDepartmentNames(): Promise<string[]> {
    return http
        .get(`${baseUrl}/names`)
        .then((resp: AxiosResponse<string[]>) => {
            return resp.data;
        });
}

export async function getDepartments(tenantId?: string): Promise<department[]> {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return http
        .get(`${baseUrl}/`, { params })
        .then((resp: AxiosResponse<department[]>) => {
            return resp.data;
        });
}

export async function addDepartment(
    name: string,
    tenantId?: string,
): Promise<department> {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return http
        .post(`${baseUrl}/`, { name }, { params: params })
        .then((resp: AxiosResponse<department>) => {
            return resp.data;
        });
}

export async function updateDepartment(
    id: string,
    name: string,
    tenantId?: string,
): Promise<department> {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return http
        .put(`${baseUrl}/${id}`, { name }, { params: params })
        .then((resp: AxiosResponse<department>) => {
            return resp.data;
        });
}

export async function deleteDepartment(
    id: string,
    tenantId?: string,
): Promise<void> {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return http
        .delete(`${baseUrl}/${id}`, { params: params })
        .then((resp: AxiosResponse<void>) => {
            return resp.data;
        });
}

export interface department {
    id: string;
    name: string;
}
